import useFlag from '@/lib/hooks/useFlag.ts';
import type TranslationKey from '@/lib/i18n/TranslationKey.ts';

type Page = {
  href: string;
  label: TranslationKey<['common', 'explore']>;
  subpages?: Page[];
};

const PAGES = {
  explore: {
    href: '/explore',
    label: 'shared.navigation.explore',
  },
  dealers: {
    href: '/explore/dealers',
    label: 'explore:dealers',
  },
  schedule: {
    href: '/schedule',
    label: 'shared.navigation.schedule',
  },
  profile: {
    href: '/profile',
    label: 'shared.navigation.profile',
  },
  party: {
    href: '/party',
    label: 'shared.navigation.party',
    subpages: [
      {
        href: '/party',
        label: 'shared.navigation.travelParty',
      },
      {
        href: '/private-parties',
        label: 'shared.navigation.partyInstance',
      },
    ],
  },
  friends: {
    href: '/friends',
    label: 'shared.navigation.friends',
  },
  /* status: {
    href: '/status',
    label: 'shared.navigation.status',
  }, */
  donate: {
    href: '/donate',
    label: 'shared.navigation.donate',
  },
  auctions: {
    href: '/auctions',
    label: 'shared.navigation.auctions',
  },
  survey: {
    href: '/survey',
    label: 'shared.navigation.survey',
  },
} as const satisfies Record<string, Page>;

const ifFeature = (feature: boolean, page: Page): Page[] => (feature ? [page] : []);

const useDefaultPages = (): Page[] => {
  const enableDealers = useFlag('dealersDen');
  const enableExplore = useFlag('explore');
  const enableSchedule = useFlag('schedule');
  const enableParty = useFlag('party');
  const enableFriends = useFlag('friends');
  // const enableStatusPage = useFlag('statusPage');
  const enableDonations = useFlag('donations');
  const enableAuctions = useFlag('auctions');
  const enablePostConSurvey = useFlag('postConSurvey');
  const dealersNavbarItem = useFlag('dealersDen.navbarItem');
  const enableProfile = useFlag('profile');

  return [
    ...ifFeature(enableExplore, PAGES.explore),
    ...ifFeature(enableDealers && dealersNavbarItem, PAGES.dealers),
    ...ifFeature(enableSchedule, PAGES.schedule),
    ...ifFeature(enableProfile, PAGES.profile),
    ...ifFeature(enableParty, PAGES.party),
    ...ifFeature(enableFriends, PAGES.friends),
    // ...ifFeature(enableStatusPage ?? false, PAGES["status"]),
    ...ifFeature(enableDonations, PAGES.donate),
    ...ifFeature(enableAuctions, PAGES.auctions),
    ...ifFeature(enablePostConSurvey, PAGES.survey),
  ];
};

export default useDefaultPages;
